import React, { FC, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { withAuthenticationRequired } from '@auth0/auth0-react'

import ReadOnlyContext from 'common/auth/ReadOnlyContext'
import breakpoints from 'common/breakpoints'
import Intercom from 'common/components/intercom/Intercom'
import Loader from 'common/components/loaders/Loader'
import TopNavBar from 'common/components/navigation/topNavBar'
import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import useDataIngestionStatusNotification from 'features/admin/dataSources/useDataIngestionStatusNotification'
import { selectIsAccountReadOnly } from 'features/auth/store/authSlice'
import { cancelCreateCampaign } from 'features/campaigns/store/campaignSlice'
import useNewLanguageWebsocketSubscription from 'features/unifiedFlow/contentPage/hooks/useNewLanguageWebsocketSubscription'

import 'common/services/HighchartsPlugin'

import Drawer from './IntegrationDrawer'
import MigratedAccountBanner from './MigratedAccountBanner'

const App: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const { accountId } = useAppSelector((state) => state.authStates)
  const isReadOnly = useAppSelector(selectIsAccountReadOnly)

  useEffect(() => {
    // handle browser back button click
    return history.listen(() => {
      if (history.action === 'POP') {
        dispatch(cancelCreateCampaign())
      }
    })
  }, [dispatch, history])

  useDataIngestionStatusNotification()
  useNewLanguageWebsocketSubscription()
  return (
    <div
      key={accountId}
      style={{ minWidth: breakpoints.xs }}
      className="flex overflow-x-auto "
    >
      <div className="flex flex-col h-screen w-full bg-gold-40 overflow-y-hidden">
        <TopNavBar />
        <MigratedAccountBanner />
        {isReadOnly ? (
          <ReadOnlyContext.Provider value={true}>
            {/* Natively disables every form control in the page body; styled to leave layout unchanged */}
            <fieldset
              disabled
              className="flex flex-col flex-1 min-w-0 min-h-0 m-0 p-0 border-0"
            >
              {children}
            </fieldset>
          </ReadOnlyContext.Provider>
        ) : (
          children
        )}
      </div>
      <Drawer />
      <Intercom />
    </div>
  )
}

// failsafe mechanism to make sure private routes are protected
export default withAuthenticationRequired(App, {
  onRedirecting: () => <Loader isFullPage />,
})
